import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/authContext';
import { projectDataClient } from '../lib/connect/clients';
export function useComplianceCoverage(projectId) {
    const { user } = useAuth();
    const cache = useQueryClient();
    const key = [
        'complianceCoverage',
        projectId,
        user?.tenant_id,
        user?.id
    ];
    const query = useQuery({
        queryKey: key,
        queryFn: ()=>projectDataClient.readComplianceCoverage({
                projectId
            }),
        enabled: !!projectId && !!user,
        retry: false,
        gcTime: 0,
        refetchOnMount: 'always'
    });
    const refresh = ()=>cache.invalidateQueries({
            queryKey: key
        });
    const mapping = useMutation({
        mutationFn: ({ item, locations })=>projectDataClient.mapComplianceCoverage({
                projectId,
                versionId: item.versionId,
                requirementId: item.requirementId,
                expectedRevision: item.revision,
                locations
            }),
        onSettled: refresh
    });
    const confirmation = useMutation({
        mutationFn: ({ item, substantiveState, evidence })=>projectDataClient.confirmComplianceCoverage({
                projectId,
                versionId: item.versionId,
                requirementId: item.requirementId,
                expectedRevision: item.revision,
                substantiveState,
                evidence
            }),
        onSettled: refresh
    });
    return {
        ...query,
        mapping,
        confirmation,
        principal: `${user?.tenant_id}:${user?.id}`
    };
}
export function requirementSource(item) {
    return JSON.parse(item.requirementJson);
}
